var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.getters['isLogin'])?_c('Header',{staticClass:"d-print-none"}):_vm._e(),(_vm.$store.getters['isShowMenu'])?_c('Menu',{staticClass:"d-print-none"}):_vm._e(),_c('Content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }